import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Settings, UserCheck, Users, GitBranch, Building2, Package, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/context/AuthContext';
import SettingsTab from './tabs/SettingsTab';
import CompanyTab from './tabs/CompanyTab';
import DocumentsTab from './tabs/DocumentsTab';
import ApprovalTab from './tabs/ApprovalTab';
import UsersTab from './tabs/UsersTab';
import BranchesTab from './tabs/BranchesTab';
import CatalogTab from '@/components/CatalogTab';

export default function ProfilePage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isOwner = user?.role === 'owner';
  const isOwnerOrManager = isOwner || user?.role === 'manager';
  const merchantId = user?.merchant_id ?? null;

  return (
    <div className="p-6 max-w-5xl mx-auto animate-fade-in">
      <h1 className="text-xl font-semibold text-foreground mb-6">{t('cust_pp.title')}</h1>

      <Tabs defaultValue="settings">
        <TabsList className="mb-6 flex-wrap">
          <TabsTrigger value="settings" className="gap-1.5">
            <Settings size={14} />
            {t('cust_pp.tab_settings')}
          </TabsTrigger>
          {isOwnerOrManager && (
            <TabsTrigger value="company" className="gap-1.5">
              <Building2 size={14} />
              {t('cust_pp.tab_company')}
            </TabsTrigger>
          )}
          {isOwnerOrManager && (
            <TabsTrigger value="documents" className="gap-1.5">
              <FileText size={14} />
              {t('merchant_documents.tab')}
            </TabsTrigger>
          )}
          {isOwnerOrManager && (
            <TabsTrigger value="branches" className="gap-1.5">
              <GitBranch size={14} />
              {t('cust_pp.tab_branches')}
            </TabsTrigger>
          )}
          {isOwner && (
            <TabsTrigger value="approval" className="gap-1.5">
              <UserCheck size={14} />
              {t('cust_pp.tab_approval')}
            </TabsTrigger>
          )}
          {isOwnerOrManager && (
            <TabsTrigger value="users" className="gap-1.5">
              <Users size={14} />
              {t('cust_pp.tab_users')}
            </TabsTrigger>
          )}
          {merchantId && (
            <TabsTrigger value="catalog" className="gap-1.5">
              <Package size={14} />
              {t('cust_pp.tab_catalog')}
            </TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="settings">
          <SettingsTab />
        </TabsContent>
        {isOwnerOrManager && (
          <TabsContent value="company">
            <CompanyTab />
          </TabsContent>
        )}
        {isOwnerOrManager && (
          <TabsContent value="documents">
            <DocumentsTab />
          </TabsContent>
        )}
        {isOwnerOrManager && (
          <TabsContent value="branches">
            <BranchesTab />
          </TabsContent>
        )}
        {isOwner && (
          <TabsContent value="approval">
            <ApprovalTab />
          </TabsContent>
        )}
        {isOwnerOrManager && (
          <TabsContent value="users">
            <UsersTab />
          </TabsContent>
        )}
        {merchantId && (
          <TabsContent value="catalog">
            <CatalogTab merchantId={merchantId} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
